module.exports = __webpack_public_path__ + "img/about-patent6.a0d829e.png";